import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import { useFieldControl } from '@/components/portal/PortalField'

export const PortalTextarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, id, ...props }, ref) => {
  const field = useFieldControl()
  const invalid = props['aria-invalid'] ?? (field?.invalid ? true : undefined)
  return (
    <textarea
      ref={ref}
      {...props}
      id={id ?? field?.id}
      aria-invalid={invalid}
      aria-describedby={props['aria-describedby'] ?? field?.describedBy}
      className={cn('prod-textarea', invalid && 'prod-textarea--invalid', className)}
    />
  )
})
PortalTextarea.displayName = 'PortalTextarea'
